<template>
    <v-dialog v-model="dialog" max-width="800">
        <v-card class="pa-5">
            <div class="d-flex align-center font-weight-medium mb-4">
                <div>
                    Configure Slack integration
                    <a :href="`https://coroot.com/docs/coroot-community-edition/alerting/slack`" target="_blank">
                        <v-icon>mdi-information-outline</v-icon>
                    </a>
                    <v-progress-circular v-if="loading" indeterminate color="green" size="30" />
                </div>
                <v-spacer />
                <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
            </div>
            <v-form ref="form" v-model="valid" :disabled="value === 'del'">
                <template v-if="integration.key">
                    <div class="subtitle-1 d-flex align-center">
                        <v-icon color="success" class="mr-1">mdi-check-circle</v-icon>
                        <div>
                            Successfully integrated with the <b>{{integration.slack.team_name}}</b> workspace
                        </div>
                    </div>
                    <div class="subtitle-1 mt-2">
                        Channels:
                    </div>
                    <div v-if="integration.slack.channels">
                        <div v-for="ch in integration.slack.channels" class="d-flex align-center py-1">
                            <div># {{ch.name}}</div>
                            <v-btn @click="test(ch.name)" small color="secondary" class="ml-2">send test alert</v-btn>
                            <v-checkbox v-model="ch.default_for_incidents" @change="(v) => setDefault(ch.name, 'incidents', v)" label="Default for alerting" dense hide-details class="ma-0 ml-2 pa-0" />
                            <v-checkbox v-model="ch.default_for_deployments" @change="(v) => setDefault(ch.name, 'deployments', v)" label="Default for deployments tracking" dense hide-details class="ma-0 ml-2 pa-0" />
                        </div>
                    </div>
                    <div v-else class="grey--text">
                        No channels connected
                    </div>

                    <div class="caption grey--text mt-4">
                        To add a channel execute: <code>/invite @Coroot</code>
                    </div>
                </template>

                <template v-else-if="integration.slack_init">
                    Click the button below to authorize Coroot to send messages to your Slack workspace.

                    <div>
                        <a :href="slackAuthUrl" class="slack-btn mt-4">
                            <img src="/static/img/slack.svg" height="40" alt="slack icon" />
                            Add to Slack
                        </a>
                    </div>
                </template>

                <v-alert v-if="error" color="red" icon="mdi-alert-octagon-outline" outlined text class="my-4">
                    {{error}}
                </v-alert>
                <v-alert v-if="message" color="green" outlined text class="my-4">
                    {{message}}
                </v-alert>
                <div class="d-flex align-center">
                    <v-spacer />
                    <v-btn v-if="value === 'del'" @click="del()" color="error">Delete</v-btn>
                    <template v-else>
                        <v-btn v-if="!integration.slack_init" @click="save()" color="primary" :disabled="!valid">Save</v-btn>
                    </template>
                </div>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        value: String,
        integration: Object,
    },

    data() {
        return {
            dialog: !!this.value,
            loading: false,
            error: '',
            message: '',
            valid: false,
        };
    },

    computed: {
        redirectUri() {
            return window.location.origin + this.$route.path;
        },
        slackAuthUrl() {
            const redirectUri = encodeURIComponent(this.redirectUri);
            return `https://slack.com/oauth/v2/authorize?client_id=${this.integration.slack_init.client_id}&scope=chat:write,channels:read,groups:read&redirect_uri=${redirectUri}`;
        },
    },

    mounted() {
        if (this.integration.slack_connect) {
            this.integration.slack_connect.redirect_uri = this.redirectUri;
            this.$router.replace({query: {code: undefined}});
            this.save();
        }
    },

    watch: {
        dialog(v) {
            this.$emit('input', v ? this.value : '');
        },
    },

    methods: {
        setDefault(channel, typ, v) {
            if (!v) {
                return;
            }
            this.integration.slack.channels.filter(ch => ch.name !== channel).forEach(ch => {
                if (typ === 'incidents') {
                    ch.default_for_incidents = false;
                }
                if (typ === 'deployments') {
                    ch.default_for_deployments = false;
                }
            })
        },
        save() {
            this.loading = true;
            this.error = '';
            this.message = '';
            this.$api.saveIntegration(this.integration, (data, meta) => {
                this.loading = false;
                if (meta.error) {
                    this.error = meta.error;
                    return;
                }
                this.message = 'Settings were successfully updated.';
                setTimeout(() => {
                    this.message = '';
                    this.dialog = false;
                }, 1000);
            });
        },
        del() {
            this.loading = true;
            this.error = '';
            this.message = '';
            this.$api.delIntegration(this.integration, (data, meta) => {
                this.loading = false;
                if (meta.error) {
                    this.error = meta.error;
                    return;
                }
                this.dialog = false;
            });
        },
        test(ch) {
            const integration = {key: this.integration.key, slack_test: {channel: ch}};
            this.loading = true;
            this.error = '';
            this.message = '';
            this.$api.testIntegration(integration, (data, meta) => {
                this.loading = false;
                if (meta.error) {
                    this.error = meta.error;
                    return;
                }
                this.message = 'A test alert has been successfully sent.';
                setTimeout(() => {
                    this.message = '';
                }, 3000);
            });
        },
    },
}
</script>

<style scoped>
.slack-btn {
    display: inline-flex;
    align-items: center;
    color: black;
    border: 1px solid rgb(221,221,221);
    border-radius: 4px;
    padding-right: 8px;
}
</style>